import AccessoryCommon from "./accessoryCommon";
import {SIDE_POSITIONS} from "../../constants";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../parts/showerTubCombo";

export default class Seats extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'shower_seats';
    this.partName = 'Seats';
    this.dbName = 'Flip-Up Seat';
    this.translateId = "visualizer.bathroom.accessories.shower_seats";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      this.layerPositions = {
        [SIDE_POSITIONS[0]]: null,
        [SIDE_POSITIONS[1]]: null,
      };
    }
  }

  load(dbFeature) {
    if (dbFeature.groupName !== "Flip-Up Seat") {
      return false
    }
    return super.loadAsBV6(dbFeature);
  }

  disabledClick() {
    Object.keys(this.layerPositions).forEach(position => {
      if (this.layerPositions[position] && this.layerPositions[position].metaData["layerPosition"]) {
        this.checkRelatedFeatureGroupPositions(this.layerPositions[position].metaData["layerPosition"]);
      }
    })
  }

  handleClick() { // "this" is feature!! not the feature group
    super.handleClick();
    const parent = this.getParent();
    const showerComboParent = parent.getParent().layout.parts[ShowerTubCombo.id]
    if (showerComboParent.showerTubComboIsActive) {
      showerComboParent.showerTubComboIsActive = false;
    }
    parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"]);
  }

  setLayers(layout) {
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerTubComboIsActive()) { //  shower tub combo - remove
      super.hideLayers();
      return;
    }

    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes) {
      Object.keys(this.layerPositions).forEach((key, keyIndex) => {
        if (this.layerPositions[key]) {
          this.layerPositions[key].layer.zIndex = zIndexes.Accessories.Seats + keyIndex*10;
        }
      })
    }
  }

}
